/**
 * Count the number of applications after filtering out classified and removed apps.
 * This applies the same filter logic used in the applications inventory.
 * @param data - The data to count
 * @returns The count
 */
export function countFilteredApplications({
    data
}: {
    data: { dateCreated: string; classified?: boolean; removed?: boolean }[];
}) {
    // Apply the filter: !(row.classified && row.removed)
    // This means we exclude apps that are both classified AND removed to match the behaviour of the applications inventory
    const filteredData = data.filter((row) => !(row.classified && row.removed));

    return [{ value: filteredData.length }];
}
